import React from 'react'
import { css, cx } from '@emotion/css'
import { getLoadingMaskColors, LoadingMaskColorValue } from './index'

const styleFactory = (colorValue: LoadingMaskColorValue) => {
  const { baseColor, shimmerColor } = getLoadingMaskColors(colorValue)
  return css`
    background: ${baseColor};
    background-repeat: repeat;
    background-image: linear-gradient(
      to right,
      ${baseColor},
      ${shimmerColor} 20%,
      ${baseColor} 40%,
      ${baseColor} 100%
    );
    background-size: 1000px;
    animation-name: shimmer;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    @keyframes shimmer {
      from {
        background-position: -500px 0;
      }
      to {
        background-position: 500px 0;
      }
    }
  `
}

export const loadingAnimationLighterCss = styleFactory('lighter')
export const loadingAnimationCss = styleFactory('normal')
export const loadingAnimationDarkerCss = styleFactory('darker')

const maskLayoutCss = css`
  height: 1em;
  flex: none;
`

export const loadingMaskCssLighter = cx(
  loadingAnimationLighterCss,
  maskLayoutCss
)
export const loadingMaskCss = cx(loadingAnimationCss, maskLayoutCss)
export const loadingMaskCssDarker = cx(loadingAnimationDarkerCss, maskLayoutCss)

const masks = ['']

for (let i = 1; i <= 10; i++) {
  masks.push(
    cx(
      loadingMaskCss,
      css`
        width: ${i * 10}%;
      `
    )
  )
}

export type LoadingTextMaskWidthFactor = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

interface Props {
  readonly min?: LoadingTextMaskWidthFactor
  readonly max?: LoadingTextMaskWidthFactor
}

export class LoadingTextMask extends React.Component<Props> {
  private className: string

  constructor(props) {
    super(props)

    const { min = 1, max = 10 } = this.props
    this.className = masks[Math.floor(Math.random() * (max + 1 - min)) + min]
  }

  public render() {
    return <div className={this.className} />
  }
}
